/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import img from "../../Assets/is.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { getMinPrice } from "../../Common/HOC/Hoc";

const ThePoints = ({
  productReducer,
  points,
  setPoints,
  updatedData,
  productData,
  onTotalPayableAmountChange,
  setBurnPoints,
  cash,
  setCash,
  minDenomination,
  productDataw,
}) => {

  const currentBalance = useSelector((state) => state.cardDataSliceReducer?.pointBalance);
  // const productId = productReducer?.id;

  // const ClientProductMappingData=useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping
  // );
  //   const productMapping = ClientProductMappingData?.find(
  //   (p) => p.productId === productId
  // );

  const selectedPriceDenomination =
    productDataw?.productReducerDisocount?.priceDenomination
      ?.split(",")
      .map(Number);

  const translation = getTranslationData();
  let totalPayableAmount = 0;
  if (!productReducer?.modalProductData) {
    updatedData?.forEach((item) => {
      const itemCost = item.denomination * item.quantity;

      // Apply customer discount
      const discountAmount = (itemCost * (productData?.customerDiscount || 0)) / 100;
      const costAfterDiscount = itemCost - discountAmount;

      // Convenience fee
      const convenienceFee = (costAfterDiscount * (productData?.convenienceFee || 0)) / 100;

      // GST on cost after discount + convenience fee
      const gstAmount = ((convenienceFee) * (productData?.gst || 0)) / 100;

      // Total amount for this item
      totalPayableAmount += costAfterDiscount + convenienceFee + gstAmount;
    });
  } else {
    productReducer?.modalProductData?.forEach((item) => {
      const itemCost = item.denomination * item.quantity;

      // Apply customer discount
      const discountAmount = (itemCost * (productData?.customerDiscount || 0)) / 100;
      const costAfterDiscount = itemCost - discountAmount;

      // Convenience fee
      const convenienceFee = (costAfterDiscount * (productData?.convenienceFee || 0)) / 100;

      // GST on cost after discount + convenience fee
      const gstAmount = ((convenienceFee) * (productData?.gst || 0)) / 100;

      // Total amount for this item
      totalPayableAmount += costAfterDiscount + convenienceFee + gstAmount;
    });
  }

  const maxBurnPoints = () => {
    const totalUnits =
      totalPayableAmount / getMinPrice(selectedPriceDenomination);
    const maxEarnPoints = productData?.maxEarnPoints;
    return Math.ceil(totalUnits * maxEarnPoints);
  };

  // Handle slider change
  const handleSliderChange = (event) => {
    const value = Math.min(Number(event.target.value), currentBalance);
    setPoints(value);

    const maxEarnPoints = productData?.maxEarnPoints;
    const conversionRate =
      maxEarnPoints / getMinPrice(selectedPriceDenomination);

    const deductedCash = value / conversionRate;
    const remainingCash = Math.max(0, totalPayableAmount - deductedCash);
    setCash(parseFloat(remainingCash.toFixed(2)));
    onTotalPayableAmountChange(remainingCash);
    setBurnPoints(value);
  };
  useEffect(() => {
    setCash(parseFloat(totalPayableAmount.toFixed(2)));
  }, [updatedData]);

  const currentPoints = useSelector((state) => state.cardDataSliceReducer?.pointBalance);

  return (
    <div className="thepoints mt-3 bnb">
      <div className="jlkkedit ddd p-4 pt-2 pb-2 mt-2">
        <div className="lsss">
          {translation?.payWithPointsAndCard} &nbsp;&nbsp;
          <img className="w-144 img" src={img} alt="img" />
        </div>
        <div className="t_aval_points mt-3 mb-2">
          {translation?.totalAvailablePoints}{" "}
          <span>
            {currentPoints?.toLocaleString()} {translation?.pts}
          </span>
        </div>
      </div>

      <div className="d-flex justify-content-between p-3 pt-1">
        <h6 className="thelcpts mx-2 d-flex align-items-center">
          <span className="pointswithprice">
            <span className="last-cart-pp1 col-2 mr-1">
              {points?.toLocaleString()} {translation?.pts}
            </span>
            <span className="lsss4">&nbsp;+&nbsp;</span>
          </span>
          <span className="lsss3">
            ₹{" "}
            {Number.isInteger(cash)
              ? cash.toLocaleString()
              : cash.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
          </span>
        </h6>
      </div>

      <div className="container jlkkedit ddd">
        <div className="d-flex align-items-center">
          <div
            className="d-flex flex-grow-1 align-items-center"
            style={{ maxWidth: "600px", marginRight: "10px" }}
          >
            <fieldset className="form-group bar-poin w-100">
              <div className="rangeSlider redeem-bar d-flex align-items-center w-100">
                <i className="fa fa-circle left-circle1"></i>

                <input
                  type="range"
                  min={0}
                  max={
                    currentBalance < maxBurnPoints()
                      ? currentBalance
                      : maxBurnPoints()
                  }
                  value={points}
                  className="rsBar flex-grow-1"
                  onChange={handleSliderChange}
                  style={{
                    width: "100%",
                    "--slider-range-percent": `${((points - 0) * 100) /
                      (((currentBalance < maxBurnPoints()
                        ? currentBalance
                        : maxBurnPoints()) || 1) -
                        0)
                      }%`,
                  }}
                />
                <i className="fa fa-circle right-circle1"></i>
              </div>
            </fieldset>
          </div>
          <span
            className="last-cart-pp1 ml-3 text-nowrap"
            style={{ whiteSpace: "nowrap" }}
          >
            {points} <span>{translation?.pts}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ThePoints;
